import React from 'react';
import { BookOpenIcon, SunriseIcon, CompassIcon } from 'lucide-react';
const stages = [{
  icon: BookOpenIcon,
  label: 'While Reading',
  points: ['The illusion starts breaking', 'Shame begins disappearing', 'Urges start losing emotional power']
}, {
  icon: SunriseIcon,
  label: 'First Week',
  points: ['Brain fog starts lifting', 'Mental clarity improves', 'Sleep and energy stabilize']
}, {
  icon: CompassIcon,
  label: 'First Month',
  points: ['Confidence returns', 'Emotional presence improves', 'You stop feeling controlled']
}];
export function Timeline() {
  return <section className="py-10 sm:py-14 bg-charcoal-light relative border-y border-gold/5" data-id="element-203">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-204">
        <div className="text-center mb-8 sm:mb-12" data-id="element-205">
          <div className="text-gold tracking-[0.2em] uppercase text-sm mb-4" data-id="element-206">
            The Journey
          </div>
          <h2 className="font-serif text-[30px] sm:text-5xl text-ivory leading-[1.15] px-2" data-id="element-207">
            What Finally Changes After Reading UNHOOKED
          </h2>
        </div>

        <div className="relative" data-id="element-208">
          {/* Desktop connecting line */}
          <div className="hidden md:block absolute top-8 left-0 w-full h-px bg-gold/20" data-id="element-209" />

          {/* Mobile connecting line */}
          <div className="md:hidden absolute top-0 left-8 bottom-0 w-px bg-gold/20" data-id="element-210" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-8" data-id="element-211">
            {stages.map((stage, index) => <div key={index} className="relative flex md:flex-col items-start md:items-center gap-6 md:gap-8" data-id="element-212">
                <div className="relative z-10 flex-shrink-0 w-16 h-16 rounded-full border border-gold/40 bg-charcoal flex items-center justify-center text-gold shadow-glow-gold" data-id="element-213">
                  <stage.icon className="w-6 h-6" data-id="element-214" />
                </div>

                <div className="md:text-center pt-2 md:pt-0" data-id="element-215">
                  <h3 className="text-gold tracking-widest uppercase text-sm mb-6 font-medium" data-id="element-216">
                    {stage.label}
                  </h3>
                  <ul className="space-y-4" data-id="element-217">
                    {stage.points.map((point, i) => <li key={i} className="text-ivory/80 text-base sm:text-lg font-light leading-relaxed" data-id="element-218">
                        {point}
                      </li>)}
                  </ul>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}